import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FilterCollection, FilterSingleSelect, FilterValue, FilterValueCollection } from '@hub/generated/models';

@Component({
  selector: 'f-filterPickerEnum',
  templateUrl: './filterPickerEnum.component.html',
  styleUrls: ['./filterPickerEnum.component.scss']
})
export class FilterPickerEnumComponent implements OnInit {
  constructor() {}

  @Input() public filter: FilterSingleSelect;

  private _filterCollection: FilterCollection;

  @Input()  set filterCollection(f: FilterCollection) {
      this._filterCollection = f;
      this.value = this.getValue();
  }
  get filterCollection() {
      return this._filterCollection;
  }

  @Output()
  public ondataChange: EventEmitter<FilterValueCollection> = new EventEmitter<FilterValueCollection>();

  public value: FilterValue;
  public columnName: string;
  public source: FilterValue[];
  public inline: boolean;

  public ngOnInit() {
    this.columnName = this.filter.ColumnName;
    this.source = this.filter.SourceValues;
    this.value = this.getValue();
  }

  public onChange() {
    let result: FilterValueCollection = new FilterValueCollection();
    result.ColumnName = this.columnName;
    let value: FilterValue = this.value;
    result.List = [value];

    this.ondataChange.emit(result);
  }

  public filterOptions(event) {
    this.source = this.filter.SourceValues.filter(item =>
      item.Value.toLowerCase().indexOf(event.query.toLowerCase()) >= 0
    );
  }

  private getValue(): FilterValue {
    if (!!this.filterCollection && !!this.filterCollection.List) {
      let values = this.filterCollection.List.filter(item =>
        item.ColumnName == this.columnName
      )[0];
      if (!!values && !!values.List && !!values.List.length)
        return values.List[0];
    }

    return null;
  }
}
